import DropzoneReact, {DropEvent} from "react-dropzone";
import * as React from "react";
import {BasePureComponent} from "../../BaseComponent";

interface ICustomDropzoneProps {
    OnDrop: (acceptedFiles: File[], rejectedFiles: File[], event: DropEvent) => any;
    AcceptedFiles?: string;
    InputFile?: File;
    NoFileMessage?: string;
    OnlySelect?: boolean;
    CustomClassName?: string;
}

export class CustomDropzone extends BasePureComponent<ICustomDropzoneProps> {
    private getContent(acceptedFiles: string, getRootProps: Function, getInputProps: Function) {
        return <div {...getRootProps()}>
            {this.getInputTemplate(acceptedFiles, getInputProps)}
        </div>
    }

    private getInputTemplate(acceptedFiles: string, getInputProps: Function) {
        if (this.props.OnlySelect) {
            return <div>
                {this.props.children}
                {<input {...getInputProps()} />}
            </div>
        }
        return this.props.children ? this.props.children :
            <div className={"dropzone dropzone--brand dz-clickable " + this.props.CustomClassName}>
                <div className="dz-message needsclick">
                    <input {...getInputProps()} />
                    <h3 className="dropzone-msg-title">{!this.props.InputFile ? this.props.NoFileMessage
                        : this.props.InputFile && this.props.InputFile.name}</h3>
                </div>
                <span className="dropzone-msg-desc">({acceptedFiles})</span>
            </div>
    }

    render() {
        const acceptedFiles = this.props.AcceptedFiles ? this.props.AcceptedFiles :
            ".jpg, .jpeg, .png, .doc, .docx, .rtf, .pdf, .odt, .xls, .xlsx, .p7m, .asics";
        return <DropzoneReact onDrop={this.props.OnDrop} accept={acceptedFiles}>
            {({getRootProps, getInputProps}) => (
                <>
                    {this.getContent(acceptedFiles, getRootProps, getInputProps)}
                </>
            )}
        </DropzoneReact>;
    }
}


// WEBPACK FOOTER //
// ./src/components/custom/Dropzone/CustomDropzone.tsx